module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded && this.items.length > 0,
      "caption": this.isLoaded ? 'Показать ' + this.topCount : 'Показать все',
      "expandable": _vm.items.length > _vm.topCount
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatCapital(_vm.capital))
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c(_vm.formatHolderRegister(_vm.holderRegister), {
    tag: "component"
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatHoldersHtml(_vm.items))
    }
  }), _vm._v(" "), _vm._l((_vm.topHolders), function(item) {
    return [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.refObject.namespace === 'ogrn'),
        expression: "item.refObject.namespace === 'ogrn'"
      }]
    }, [_c(_vm.createCompanyComp(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.refObject.namespace === 'HUMAN'),
        expression: "item.refObject.namespace === 'HUMAN'"
      }]
    }, [_c(_vm.createHumanComp(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.refObject.namespace === 'FOREIGN'),
        expression: "item.refObject.namespace === 'FOREIGN'"
      }]
    }, [_c(_vm.createNoInnHolder(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.refObject.namespace === 'MUNICIPAL'),
        expression: "item.refObject.namespace === 'MUNICIPAL'"
      }]
    }, [_c(_vm.createNoInnHolder(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.refObject.namespace === 'PIF'),
        expression: "item.refObject.namespace === 'PIF'"
      }]
    }, [_c(_vm.createNoInnHolder(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.refObject.namespace === 'OTHER'),
        expression: "item.refObject.namespace === 'OTHER'"
      }]
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderHolderPercent(item))
      }
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatWarningHtml('Запись об учредителе не поддерживается.'))
      }
    }), _vm._v(" "), _c('div', [_c('b', [_vm._v(_vm._s(_vm.formatShare(item)))]), _vm._v(_vm._s(_vm.renderDateSince(item)))])])], 1), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderUnreliableHtml(item))
      }
    })]
  })], 2)]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    staticClass: "pt-0"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [(_vm.items.length === 0) ? _c('v-flex', [_vm._v("\n        Данные не найдены.\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.items.length > 0 && _vm.items.length > 100),
      expression: "items.length > 0 && items.length > 100"
    }]
  }, [_c('b', [_vm._v("ВАЖНО!")]), _vm._v(" Показываются только 100 учредителей, отфильтрованных по величине доли. Для показа всех учредителей направьте нам письмо на электронную почту " + _vm._s(_vm.getOpenSettings.supportMail)), _c('br'), _c('br')]), _vm._v(" "), _vm._l((_vm.lowHolders), function(item) {
    return [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.refObject.namespace === 'ogrn'),
        expression: "item.refObject.namespace === 'ogrn'"
      }]
    }, [_c(_vm.createCompanyComp(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.refObject.namespace === 'HUMAN'),
        expression: "item.refObject.namespace === 'HUMAN'"
      }]
    }, [_c(_vm.createHumanComp(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.refObject.namespace === 'FOREIGN'),
        expression: "item.refObject.namespace === 'FOREIGN'"
      }]
    }, [_c(_vm.createNoInnHolder(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.refObject.namespace === 'MUNICIPAL'),
        expression: "item.refObject.namespace === 'MUNICIPAL'"
      }]
    }, [_c(_vm.createNoInnHolder(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.refObject.namespace === 'PIF'),
        expression: "item.refObject.namespace === 'PIF'"
      }]
    }, [_c(_vm.createNoInnHolder(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.refObject.namespace === 'OTHER'),
        expression: "item.refObject.namespace === 'OTHER'"
      }]
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderHolderPercent(item))
      }
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatWarningHtml('Запись об учредителе не поддерживается.'))
      }
    }), _vm._v(" "), _c('div', [_c('b', [_vm._v(_vm._s(_vm.formatShare(item)))]), _vm._v(_vm._s(_vm.renderDateSince(item)))])])], 1), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderUnreliableHtml(item))
      }
    })]
  })], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a205d7d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/HoldersPanel.vue
// module id = 1036
// module chunks = 1